var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('hight-light',{attrs:{"is-bg":true,"text":"小U答疑"}}),_vm._l((_vm.answer),function(item){return _c('introduce',{key:item.title,attrs:{"is-left":item.isLeft,"text":item.text,"title":item.title,"img":item.img,"is-white":item.isWhite}})})],2),_c('div',{staticStyle:{"height":"22px","background-color":"#fff"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }